import React, { useCallback, useContext, useEffect, useState } from "react";
import "../../DrugAssignmentBatchRelease/DrugAssignment.css";
import { Link, useNavigate } from "react-router-dom";
import { Divider, Grid2 } from "@mui/material";
import { MenuContext } from "../../../App";
import Loader from "../../../components/Loader";
import StyledGridComp from "../../../components/StyledGridComp";
import { fetchAllLotManagementDataService } from "../../../services/lotManagementServices";
import { InfoOutlined } from "@mui/icons-material";

const IndividualDrugKitStatus = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [canAddLot, setCanAddLot] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchedValue, setSearchedValue] = useState("");
  const navigate = useNavigate();

  const access_token = localStorage?.getItem("access_token");
  const role = localStorage.getItem("role");

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      //   fetchAllLotManagementData(page, pageSize, access_token, debouncedSearch);
    }
  }, [pageSize, page, debouncedSearch]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(searchedValue);
    }, 500);
    return () => clearTimeout(timeout);
  }, [searchedValue]);

  const columns = [
    {
      field: "drugKitNumber",
      headerName: "Drug Kit Number",
      width: 300,
      renderHeader: () => (
        <div className="grid-heading">{"Drug Kit Number"}</div>
      ),
      renderCell: (params) => {
        const name = params.row.drugKitNumber;
        const id = params.row.id;

        return (
          <>
            <button
              className="bread-crumbs-link"
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/addUpdate-lot-management", {
                  state: {
                    id: id,
                  },
                });
              }}
            >
              {name}
            </button>
          </>
        );
      },
    },
    {
      field: "sequenceNumber",
      headerName: "Sequence Number",
      width: 300,
      renderHeader: () => (
        <div className="grid-heading">{"Sequence Number"}</div>
      ),
      renderCell: (params) => {
        const sequenceNumber = params.row.sequenceNumber;

        return <span>{sequenceNumber}</span>;
      },
    },
    {
      field: "currentStatus",
      headerName: "Current Status",
      width: 300,
      renderHeader: () => (
        <div className="grid-heading">{"Current Status"}</div>
      ),
      renderCell: (params) => {
        const currentStatus = params.row.currentStatus;

        return <span>{currentStatus}</span>;
      },
    },
    {
      field: "changeStatusTo",
      headerName: "Change Status To",
      width: 300,
      renderHeader: () => (
        <div className="grid-heading">{"Change Status To"}</div>
      ),
      renderCell: (params) => {
        const changeStatusTo = params.row.changeStatusTo;

        return <span>{changeStatusTo}</span>;
      },
    },
  ];

  const fetchAllLotManagementData = async (
    page,
    pageSize,
    access_Token,
    debouncedSearch = ""
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllLotManagementDataService(
        page + 1,
        pageSize,
        access_Token,
        debouncedSearch
      );
      if (res?.status === 200) {
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
        setLoad(false);
      } else if (res?.status == 401) {
        navigate("/unauthorize");
      }
    } catch (err) {
      setLoad(false);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  return (
    <>
      <div className="content-body">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/individual-drug-kit-status">
            Individual Drug Kit Status Management
          </Link>{" "}
          -{" "}
          <b style={{ color: "gray" }}>
            {localStorage?.getItem("studyName")}
          </b>
        </p>
        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2 item md={12} sx={{ width: "100%" }}>
            <p className="page-heading">
              Individual Drug Kit Status Management
            </p>
            <Divider />
            <p className="page-sub-header">
              <InfoOutlined className="info-icon" />
              If you want to make an update to a large number of kits units,
              please use the
              <button
                className="bread-crumbs-btn"
                onClick={(e) => navigate("/bulk-drug-kit-status")}
                style={{ fontSize: "14px" }}
              >
                Bulk update function
              </button>
            </p>
          </Grid2>
        </Grid2>

        {load ? (
          <Loader />
        ) : (
          <StyledGridComp
            rows={rowData}
            columns={columns}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            length={rowLength}
          ></StyledGridComp>
        )}

        <Grid2
          alignItems={"end"}
          justifyContent="end"
          container
          gap={3}
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button
              type="button"
              className="create-btn-outlined"
              onClick={(e) => {}}
            >
              Back
            </button>
          </Grid2>
          <Grid2 item md={6}>
            <button onClick={(e) => {}} className={"create-btn"}>
              Save
            </button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default IndividualDrugKitStatus;
